import { createFileRoute } from '@tanstack/react-router'
import EditTemplatePage from '@/features/templates/edit'

export const Route = createFileRoute('/_authenticated/templates/$templateId')({
  component: EditTemplatePage,
})
